export class Player {
    private playbackNode: AudioWorkletNode | null = null;
    private audioContext: AudioContext | null = null; // Keep a reference
    private onEndedCallback: (() => void) | null = null;

    async init(sampleRate: number) {
        this.audioContext = new AudioContext({ sampleRate });
        await this.audioContext.audioWorklet.addModule("audio-playback-worklet.js");

        this.playbackNode = new AudioWorkletNode(this.audioContext, "audio-playback-worklet");
        this.playbackNode.connect(this.audioContext.destination);

        this.playbackNode.port.onmessage = event => {
            if (event.data === "ended" && this.onEndedCallback) {
                this.onEndedCallback();
                this.onEndedCallback = null;
            }
        };
    }

    async play(buffer: Int16Array, onEnded?: () => void) {
        if (!this.playbackNode || !this.audioContext) return;

        // If the audio context got suspended, resume it:
        if (this.audioContext.state === "suspended") {
            await this.audioContext.resume();
        }

        this.onEndedCallback = onEnded || null;
        this.playbackNode.port.postMessage(buffer);
    }

    stop() {
        if (this.playbackNode) {
            this.playbackNode.port.postMessage(null);
            this.onEndedCallback = null;
        }
    }
}
